import { render } from "./SeverityLevelsChart.vue?vue&type=template&id=a6ee2fb4"
import script from "./SeverityLevelsChart.vue?vue&type=script&lang=js"
export * from "./SeverityLevelsChart.vue?vue&type=script&lang=js"

import "./SeverityLevelsChart.vue?vue&type=style&index=0&id=a6ee2fb4&lang=scss"

import exportComponent from "/builds/flowberry1/flowberry/user-interface/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import qInstall from "../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QInnerLoading,QSpinner});
